module.exports = __webpack_public_path__ + "static/img/guarantee.7d4d8df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/guarantee.jpg
// module id = 1EGF
// module chunks = 4